/* eslint-disable no-param-reassign */
import produce from 'immer';
import types from './types';

const INITIAL_FILTER = {
  page: 1,
};

const INITIAL_STATE = {
  filter: INITIAL_FILTER,
  list: {},
  visitorDetails: null,
};

export default function reducer(baseState = INITIAL_STATE, action) {
  return produce(baseState, (draftState) => {
    switch (action.type) {
      case types.VISITORS_SET_STATE: {
        Object.keys(action.payload.state).forEach((objectKey) => {
          draftState[objectKey] = action.payload.state[objectKey];
        });
        break;
      }
      default:
    }
  });
}
